// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"cc7899ae","215":"a0ebf251"}[chunkId] + ".chunk.js";
};